import { Box, GridItem, Heading, Text } from "@chakra-ui/react";
import React from "react";

const TimelineItem = ({ item, isFirst, isLast }) => (
    <>
        <GridItem>
            <Box>
                <Text textAlign="right">{item.leftTop}</Text>
                <Text textAlign="right">{item.leftBottom}</Text>
            </Box>
        </GridItem>
        <GridItem
            display="flex"
            alignItems="center"
            justifyContent="center"
            pos="relative"
            h="100%"
            _before={!isFirst && {
                content: '""',
                pos: "absolute",
                display: "block",
                w: "2px",
                h: "calc(50% + 0.875rem)",
                bg: 'gray.400',
                top: "-0.875rem",
                left: '50%',
                transform: 'translateX(-50%)'
            }}
            _after={!isLast && {
                content: '""',
                pos: "absolute",
                display: "block",
                w: "2px",
                h: "calc(50% + 0.875rem)",
                bg: 'gray.400',
                bottom: "-0.875rem",
                left: '50%',
                transform: 'translateX(-50%)'
            }}
        >
            <Box
                borderRadius="100%"
                bg="gray.700"
                h="31px"
                w="31px"
                zIndex={10}
            ></Box>
        </GridItem>
        <GridItem display="flex" gap="0.5rem" flexDirection="column">
            {item.right.map(text => (
                <Box>
                    <Text fontSize={['xs', 'sm']} color="primary.2">{text.subTitle}</Text>
                    <Heading as="h4" fontSize={['sm', 'md']} color="primary.1">{text.title}</Heading>
                </Box>
            ))}
        </GridItem>
    </>
);

export default TimelineItem;